import React from 'react'

function GetBotSubType() {
  return (
    <div>GetBotSubType</div>
  )
}

export default GetBotSubType